"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../lib/helpers");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const Breadcrumbs = (props) => {
    const { children } = props;
    return (react_1.default.createElement("div", Object.assign({}, helpers_1.usePrimitiveProps(props)), react_1.default.Children.map(children, (node, index) => (react_1.default.createElement(react_1.default.Fragment, null,
        node,
        (index + 1) !== react_1.default.Children.count(children) && react_1.default.createElement("span", null, '>'))))));
};
exports.default = withJourney_1.default('j-breadcrumbs', Breadcrumbs);
